import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import rootReducer from "../Reducer/Index";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";
import types from "../ActionTypes/Index";
const persistConfig = {
  key: "root",
  storage,
  // In-flight request state is transient. Persisting it means a page closed
  // mid-request rehydrates with a non-zero pending count and shows the loading
  // indicator forever.
  blacklist: ["LoadingIndicatorReducer"],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: false,
    }).concat(
      createStateSyncMiddleware({
        // Loader traffic is per-tab. Broadcasting it lets one tab's requests
        // drive another tab's indicator, and a tab closed mid-request leaves the
        // listening tabs with a pending count that never comes back down.
        blacklist: [types.SHOW_LOADER, types.HIDE_LOADER],
      })
    ),
});
initMessageListener(store);
export default store;
